// extracted by mini-css-extract-plugin
export default {"defaultButton":"styles_defaultButton__t2xXq"};